export default __webpack_public_path__ + "static/media/area-41.fd950c94.jpg";